import React, { useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { aptInfoApi } from "../fetchers";
import { areaResponse, dongResponse, hoResponse } from "../types/response";
import { searchTextState, selectState } from "../store";

function Selector() {
  const [selectDong, setSelectDong] = useRecoilState(selectState.dong);
  const [inputText, setInputText] = useState("");
  const setSelectHo = useSetRecoilState(selectState.ho);
  const setSelectArea = useSetRecoilState(selectState.area);
  const setSearchText = useSetRecoilState(searchTextState);

  const { data: aptInfoData } = useQuery({
    queryKey: ["aptId"],
    queryFn: () => aptInfoApi.getInfo(),
  });

  const { data: dongData } = useQuery<
    dongResponse,
    AxiosError,
    dongResponse,
    any
  >({
    queryKey: ["dongData"],
    queryFn: aptInfoApi.getDong(aptInfoData?.apt.id),
    enabled: !!aptInfoData,
  });

  const { data: hoData } = useQuery<hoResponse, AxiosError, hoResponse, any>({
    queryKey: ["hoData", selectDong],
    queryFn: () => aptInfoApi.getHo(aptInfoData?.apt.id, selectDong),
    enabled: !!selectDong,
  });

  const { data: areaData } = useQuery<
    areaResponse,
    AxiosError,
    areaResponse,
    any
  >({
    queryKey: ["areaData"],
    queryFn: () => aptInfoApi.getArea(aptInfoData?.apt.id),
    enabled: !!aptInfoData,
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    type: string
  ) => {
    const selectValue = e.target.value;

    switch (type) {
      case "dong":
        setSelectDong(selectValue);
        break;
      case "ho":
        setSelectHo(selectValue);
        break;
      case "area":
        setSelectArea(selectValue);
        break;
      default:
        break;
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputText(e.target.value);
  };

  const handleSubmit = () => {
    setSearchText(inputText);
  };

  return (
    <div className="row mx-0 justify-content-between">
      <div className="form-row">
        <div className="col-auto">
          <select
            id="dong"
            className="form-control"
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              handleChange(e, "dong")
            }
          >
            <option value="">전체 동</option>
            {dongData &&
              dongData.data.map((value) => (
                <option key={value.dong} value={value.dong}>
                  {value.dong_name}
                </option>
              ))}
          </select>
        </div>
        <div className="col-auto">
          <select
            id="ho"
            className="form-control"
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              handleChange(e, "ho")
            }
          >
            <option value="">전체 호</option>
            {hoData ? (
              hoData.data.map((value) => (
                <option key={value.ho} value={value.ho}>
                  {value.ho_name}
                </option>
              ))
            ) : (
              <option>호 선택</option>
            )}
          </select>
        </div>
        <div className="col-auto">
          <select
            id="area"
            className="form-control"
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              handleChange(e, "area")
            }
          >
            <option value="">전체 선거구</option>
            {areaData &&
              areaData.data.map((value) => (
                <option key={value.areaCode} value={value.areaCode}>
                  {value.area}
                </option>
              ))}
          </select>
        </div>
      </div>
      <div className="input-group col-3 px-0">
        <input
          className="form-control bg-white"
          placeholder="이름"
          value={inputText}
          onChange={handleInputChange}
        />
        <div className="input-group-append" onClick={handleSubmit}>
          <button className="btn btn-secondary">검색</button>
        </div>
      </div>
    </div>
  );
}

export default Selector;
